import React from 'react';

import { DragHandleButtonSmall } from '../src/drag-handle-button-small';

export default function DragHandleButtonSmallExample(): React.JSX.Element {
	return (
		<React.StrictMode>
			<DragHandleButtonSmall label="Reorder" />
		</React.StrictMode>
	);
}
